import { render, staticRenderFns } from "./TextLanguagesDialog.vue?vue&type=template&id=b5ca84a0&scoped=true&lang=pug&"
import script from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TextLanguagesDialog.vue?vue&type=style&index=0&id=b5ca84a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca84a0",
  null
  
)

export default component.exports